import { useEffect, useState } from 'react';
import history from '../../../../../../../../history';
import { UnlinkFromDsoButton } from '../../../../../../User/components/DsoName/components/UnlinkFromDsoButton';
import { DsoFilter } from '../../../../../../UsersList/OfficeAdminList/components/TableHeader/DsoFilter/DsoFilter';

export const AssignDso = ({
  value,
  onSave,
  allowDisableSaveButton = true,
  showUnlinkFromOfficeButton = false,
}) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value);

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  const handleOnCancel = () => {
    setIsEditMode(false);
    setSelectedOption(value);
  };

  const handleOnEdit = () => {
    setIsEditMode(true);
  };

  const handleOnSave = () => {
    onSave(selectedOption);
    setSelectedOption(value);
    setIsEditMode(false);
  };

  const handleViewDSOClick = () => {
    history.push(`/dsos/${value.id}/orgStructure`);
  };

  return (
    <div className="card mb-2">
      <div
        className="card-body"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignContent: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <h3 className="card-title" style={{ textAlign: 'center' }}>
            DSO Name
          </h3>
          <br />
          {isEditMode ? (
            <div style={{ paddingInline: 32 }}>
              <DsoFilter
                filters={{
                  dsoId: selectedOption?.id,
                }}
                label=""
                placeholder="Select DSO"
                handleFilterChanged={(_, value, label) => {
                  setSelectedOption({
                    id: value,
                    label,
                  });
                }}
              />
            </div>
          ) : (
            <h4 style={{ textAlign: 'center', width: '100%' }}>{value?.label || 'Not selected'}</h4>
          )}
        </div>
        <div
          style={{
            marginTop: 32,
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              display: 'flex',
              gap: 20,
            }}
          >
            {isEditMode ? (
              <>
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{
                    width: '100px',
                  }}
                  onClick={handleOnCancel}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-success"
                  style={{
                    width: '100px',
                  }}
                  onClick={handleOnSave}
                  disabled={allowDisableSaveButton && !selectedOption?.id}
                >
                  Save
                </button>
              </>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: !showUnlinkFromOfficeButton ? 'row' : 'column',
                  gap: 16,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {!!value.id && (
                  <div
                    style={{
                      display: 'flex',
                      gap: 16,
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-success"
                      style={{ width: '100px' }}
                      onClick={handleViewDSOClick}
                    >
                      View DSO
                    </button>
                    {showUnlinkFromOfficeButton && <UnlinkFromDsoButton />}
                  </div>
                )}
                <button
                  type="button"
                  className="btn btn-info"
                  style={{ width: '100px' }}
                  onClick={handleOnEdit}
                >
                  Edit
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
